import { Fragment } from "react"
import AppleTouchIcon from "./AppleTouchIcon"

const DocumentHead = () => {
    return <Fragment>
        <AppleTouchIcon />
    </Fragment>
}

export default DocumentHead